import { consoleEvents, LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import actions from './actions'
import initialState from './initialState'
import UnreviewedProductsState from './types'

const fetchUnreviewedProductsDataStart = (
  state: UnreviewedProductsState,
): UnreviewedProductsState => ({
  ...state,
  creatingReviewSubmitted: false,
  loadingUnreviewedProductsStatus: LoadingStates.Loading,
})

const fetchUnreviewedProductsDataFail = (
  state: UnreviewedProductsState,
): UnreviewedProductsState => {
  consoleEvents.error('Failed to fetch unreviewed products')

  return {
    ...state,
    loadingUnreviewedProductsStatus: LoadingStates.LoadedFail,
  }
}

const fetchUnreviewedProductsDataSuccess = (
  state: UnreviewedProductsState,
  data,
): UnreviewedProductsState => {
  return {
    ...state,
    totalNumberOfUnreviewedProducts: data.total,
    unreviewedProducts: data.purchasedProducts,
    loadingUnreviewedProductsStatus: LoadingStates.LoadedSuccess,
  }
}

const creatingReviewStart = (state: UnreviewedProductsState): UnreviewedProductsState => ({
  ...state,
  loadingUnreviewedProductsStatus: LoadingStates.Loading,
})

const creatingReviewFail = (state: UnreviewedProductsState): UnreviewedProductsState => {
  consoleEvents.error('Failed to fetch unreviewed products')

  return {
    ...state,
    loadingUnreviewedProductsStatus: LoadingStates.LoadedFail,
  }
}

const creatingReviewSuccess = (state: UnreviewedProductsState): UnreviewedProductsState => {
  return {
    ...state,
    creatingReviewSubmitted: true,
    headerStatus: 'submitted',
    loadingUnreviewedProductsStatus: LoadingStates.LoadedSuccess,
  }
}

const reducer = createReducer<UnreviewedProductsState>((on) => {
  on(actions.fetchUnreviwedProductsStart, fetchUnreviewedProductsDataStart)
  on(actions.fetchUnreviwedProductsSuccess, fetchUnreviewedProductsDataSuccess)
  on(actions.fetchUnreviwedProductsFail, fetchUnreviewedProductsDataFail)
  on(actions.createReviewStart, creatingReviewStart)
  on(actions.createReviewFail, creatingReviewFail)
  on(actions.createReviewSuccess, creatingReviewSuccess)
}, initialState)

export default reducer
